document.querySelectorAll('[data-zi-col-hero-description-wrap]').forEach(function (wrap) {
  var description = wrap.querySelector('[data-zi-col-hero-description]');
  var toggle = wrap.querySelector('[data-zi-col-hero-description-toggle]');

  if (!description || !toggle) return;

  if (description.scrollHeight > description.clientHeight + 1) {
    toggle.hidden = false;
  }

  toggle.addEventListener('click', function () {
    var isClamped = description.classList.toggle('is-clamped');
    toggle.textContent = isClamped ? 'Preberi več' : 'Prikaži manj';
  });
});
